import { Tab } from '@headlessui/react';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTheme } from 'styled-components';

import { SpinningIcon } from '@/components/common/spinning-icon';
import { IBatch } from '@/features/single-measurement/types';
import { useRoute } from '@/hooks/use-route';

// manages the state of individual batch within the fermentation view
export const BatchTabGroup = ({
  batches,
  isLoading,
  fermentationId,
}: {
  batches?: IBatch[];
  isLoading: boolean;
  fermentationId: string;
}) => {
  const theme: any = useTheme();
  const { routeToFermentationBatch } = useRoute();
  const { batchId = '' } = useParams();

  /**
   * when user change the tab in tab group, route to the relavant URL.
   * example: <baseURL>/fermentations/:<fermentationId>/batch/:<batchId>
   *
   * then fermentation page will be updated based on the route,
   * there's a URL param change listener in the fermentation.tsx page
   *
   */
  const handleTabChange = (index: number) => {
    routeToFermentationBatch({ fermentationId, batchId: batches![index].id });
  };

  useEffect(() => {
    if (batches && batches?.length > 0 && !batchId) handleTabChange(0);
  }, [batches]);

  if (isLoading) return <SpinningIcon color={`fill-${theme}-primary`} />;

  const tabs = () => {
    return (
      batches &&
      batches?.map((batch) => (
        <Tab
          key={batch.id}
          className={`flex-shrink-0 py-1 px-4 border rounded-t-md ui-selected:border-wine-primary focus:outline-none uppercase text-black-dark w-36 truncate ${
            batch.id === batchId
              ? 'bg-gray border-gray font-bold'
              : 'bg-gray-100 border-gray-100'
          }`}
        >
          {batch.name ? batch.name : batch.id.substring(0, 10)}
        </Tab>
      ))
    );
  };

  return (
    <Tab.Group onChange={handleTabChange}>
      <Tab.List className="flex gap-3 border-b-2 text-black-dark overflow-x-auto scrollbar-thin scrollbar-thumb-rounded-full scrollbar-thumb-gray scrollbar-track-gray-100">
        {tabs()}
      </Tab.List>
    </Tab.Group>
  );
};
